export default __webpack_public_path__ + "images/react/components/trial-signup/assets/signup-page2-cb-retention.png";